import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType, IAPIresponse } from '../../model';
import { ADMIN_PREFIX } from '../config';

// 迁移游戏
export const postGameMigration = (gameID: string, studioID: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/game/migration/${gameID}/to/${studioID}`;
      const response = await api.commonRequest('POST', url);
      const res = await parsedResponse<IAPIresponse>(response, 'all');
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  });
